import React from 'react';
import { NotificationList } from './NotificationList';
import { Container, Icon, Count, Error, DisplayMsg } from './NotificationStyles';

interface IProps{
    count: number,
    list: any[],
    error: string,
    displayAllBtn: boolean
}
interface IState{
    visibleList: boolean
}
export class Notification extends React.Component<IProps, IState> {
    constructor(props:any) {
        super(props);
        this.state = {
            visibleList: false
        }
    }
    public componentDidUpdate(props:any, state:any){
        if(this.state.visibleList !== state.visibleList){
            if(this.state.visibleList === true){
                document.addEventListener('click', this.onClickToggle);
            }else{
                document.removeEventListener('click', this.onClickToggle);
            }
        }
    }
    public componentWillUnmount(){
        document.removeEventListener('click', this.onClickToggle);
    }
    public render() {
        return (
            <Container>
                <Icon onClick={this.onClickToggle}>
                    <i className="fa fa-bell" aria-hidden="true" />
                </Icon>
                {this.props.error && this.props.error.length > 0 && <>
                    <Error><i className="fa fa-exclamation" aria-hidden="true" /></Error>
                </>}
                {this.props.count > 0 && 
                    <Count onClick={this.onClickToggle}>{ this.props.count > 99 ? '99+': this.props.count }</Count>
                }
                {this.state.visibleList && this.props.error && <DisplayMsg>{this.props.error}</DisplayMsg>}
                {this.state.visibleList && this.props.list && this.props.list.length > 0 && <NotificationList displayAllBtn={this.props.displayAllBtn} isVisible={this.state.visibleList} data={this.props.list} />}
            </Container>
        );
    }
    public onClickToggle = () => this.setState({ visibleList: !this.state.visibleList})
}
